import axios from 'axios';
import apiClient from '@/shared/services/apiClient';
import type { LoginResponse, UserInfo } from '@/shared/types/api';

export async function login(username: string, password: string): Promise<LoginResponse> {
  const res = await apiClient.post('/auth/login', { username, password });
  return res.data;
}

export async function register(email: string, username: string, password: string): Promise<{ message: string; email: string }> {
  const res = await apiClient.post('/auth/register', { email, username, password });
  return res.data;
}

export async function verify(email: string, code: string): Promise<{ message: string }> {
  const res = await apiClient.post('/auth/verify', { email, code });
  return res.data;
}

export async function resendCode(email: string): Promise<{ message: string }> {
  const res = await apiClient.post('/auth/resend-code', { email });
  return res.data;
}

export async function forgotPassword(email: string): Promise<{ message: string }> {
  const res = await apiClient.post('/auth/forgot-password', { email });
  return res.data;
}

export async function resetPassword(token: string, new_password: string): Promise<{ message: string }> {
  const res = await apiClient.post('/auth/reset-password', { token, new_password });
  return res.data;
}

export async function getMe(): Promise<UserInfo> {
  const res = await apiClient.get('/auth/me');
  return res.data;
}

export async function changePassword(current_password: string, new_password: string): Promise<{ message: string }> {
  const res = await apiClient.put('/auth/me/password', { current_password, new_password });
  return res.data;
}

export async function refreshAccessToken(refreshToken: string): Promise<LoginResponse> {
  const res = await axios.post('/api/v1/auth/refresh', { refresh_token: refreshToken });
  return res.data;
}
